import Dropdown from 'bootstrap/js/dist/dropdown';

export default function Dropdowns(dropdowns) {
  dropdowns.forEach((el) => {
    el.dropdown = new Dropdown(el);
  });
}
